import styled, { css } from "styled-components"
import { color } from "../../../atoms/colors"
import { font } from "../../../atoms/typography"

export const ROIWrapper = styled.div`
  width: 100%;
  z-index: 1;
  * {
    font-family: 'Roboto';
  }
`

export const Content = styled.div`
  width: 100%;
  max-width: 970px;
  margin: 0 auto;
  @media (max-width: 992px) {
    max-width: 770px;
  }
  @media (max-width: 576px) {
    max-width: 506px;
  }
`

export const Calculator = styled.div`
  display: grid;
  padding: 40px;
  background: ${color.common.white};
  border: 1px solid ${color.grey[200]};
  box-shadow: 0px 20px 30px rgba(16, 24, 40, 0.05);
  border-radius: 12px;
  grid-row-gap: 32px;
  @media (max-width: 576px) {
    padding: 24px;
    grid-row-gap: 24px;
  }
`

export const CalcTitle = styled.h2`
  ${font('display', 'xs', '700')}
  color: ${color.common.black};
  text-align: center;
  ${(props) => props && props.isDetail && css`
    text-align: left;
  `}
`
